<template>
  <div class="text-center justify-content-center">
    <img :src="thisimagename">
    <div
      style="position: absolute; top: 100px; left: 0px;z-index: 20;"
      class="box w-100 justify-content-center flex-column"
    >
      <h3>{{ progress }}%</h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressCircle',
  props: {
    membercount: {
      type: Number,
      default: 0
    },
    completecount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    thisimagename: function () {
      var imagename = ''
      var percent = 0
      if (this.membercount == 0) {
        percent = 0
      } else {
        percent = (this.completecount * 100) / this.membercount
      }
      var rounded = Math.round((percent / 10)) * 10
      if (rounded < 95) {
        imagename = ('00' + rounded).slice(-2) + '.gif'
      } else {
        imagename = '100.gif'
      }
      return require('../assets/GDQ-matcirkel_' + imagename)
    },
    progress: {
      get () {
        var progress = 0
        if (this.membercount == 0) {
          progress = 0
        } else {
          progress = Math.round((this.completecount / this.membercount) * 100, 0)
        }
        return progress
      },
      set () {
        return true
      }
    }
  }
}
</script>
<style scoped>
</style>
